 (() => {
  'use strict';

  if (window.OG_ADDON_POPUP_LOADED) return;
  window.OG_ADDON_POPUP_LOADED = true;

  const FEE_VARIANT_BY_AMOUNT = {
    "0": 43953269866630,
    "49": 43850576625798,
    "99": 43850576658566,
    "149": 43850576691334,
    "199": 43850576724102,
    "249": 43850576756870,
    "250": 43850576789638,
    "299": 43850576822406,
    "300": 43853818134662,
    "349": 43850576855174,
    "350": 43853881704582,
    "399": 43850576887942,
    "400": 43855451160710,
    "450": 43855451193478,
    "500": 43850576986246,
    "550": 43855451226246
  };

  const OG_OCCASION_INDEX = [{"id":1,"name":"Congratulation"},{"id":2,"name":"Get Well Soon"},{"id":3,"name":"Just Like That"},{"id":4,"name":"Love & Romance"},{"id":5,"name":"New Born"},{"id":6,"name":"Cheer Up"},{"id":7,"name":"Appreciation"},{"id":8,"name":"Thank U"},{"id":9,"name":"Wedding"},{"id":10,"name":"Eid"},{"id":11,"name":"Onam"},{"id":12,"name":"Parents Day"},{"id":13,"name":"Friendship Day"},{"id":14,"name":"Independence Day"},{"id":15,"name":"Teacher's Day"},{"id":16,"name":"Grandparent's Day"},{"id":17,"name":"Daughter's Day"},{"id":18,"name":"Ganesh Chaturthi"},{"id":19,"name":"Karwa Chauth"},{"id":20,"name":"Diwali"},{"id":21,"name":"Lohri"},{"id":22,"name":"April Fool"},{"id":23,"name":"New Year"},{"id":24,"name":"Rakhi"},{"id":25,"name":"Propose Day"},{"id":26,"name":"Chocolate Day"},{"id":27,"name":"Valentines Day"},{"id":28,"name":"Hug Day"},{"id":29,"name":"Kiss Day"},{"id":30,"name":"Teddy Day"},{"id":31,"name":"Promise Day"},{"id":32,"name":"Rose Day"},{"id":33,"name":"Holi"},{"id":34,"name":"Women's Day"},{"id":35,"name":"Mother's Day"},{"id":36,"name":"Father's Day"},{"id":37,"name":"Birthday"},{"id":38,"name":"Anniversary"},{"id":39,"name":"Miss You"},{"id":40,"name":"I am Sorry"},{"id":41,"name":"Thinking of You"},{"id":42,"name":"Best of Luck"},{"id":43,"name":"House Warming"},{"id":44,"name":"Sympathy & Funerals"},{"id":45,"name":"Christmas"}];

  const DEFAULT_CONFIG = {
    collectionHandle: 'addons',
    collectionUrl: '',
    collectionProductsJsonUrl: '',
    productTags: [],
    currentProductIsExpress: false,
    currentProductIsCourier: false,
    currentProductHasAddons: false,
    addonSource: 'none',
    occasionMessagesUrl: '',

    buyNowSelector: 'button[id^="ProductSubmitButton-"], button[name="add"], .product-form__submit, [type="submit"][name="add"]',
    productFormSelector: 'form[action*="/cart/add"]',

    requiredProductTag: '',
    cartDrawerSelector: 'cart-drawer#CartDrawer, cart-drawer, #CartDrawer.cart-drawer, #CartDrawer',
    cartDrawerTriggerSelector: '',

    openCartDrawerAfterAdd: true,
    openCartDrawerOnPopupClose: true,
    redirectToCartAfterAdd: false,
    redirectToCheckoutAfterAdd: false,

    requireDeliverySelection: true,
    requireOptisRequiredOptions: true,

    requireSenderName: false,
    requireSenderPhone: false,
    requireMessage: false,

    maxAddonsProductsToShow: 50,
    maxAddonsSelectable: 50,

    addonCategories: [],
    defaultAddonCategoryKey: 'popular',

    enableSkipAddons: true,
    strictBlockAddonVariants: true,

    senderStorageHours: 24,
    currencySymbol: '₹',

    enableDeliveryFeeItem: true,
    deliveryFeeProductId: 7579687125126,
    deliveryFeeVariantByAmount: FEE_VARIANT_BY_AMOUNT,

    deliveryFeeFallbackByType: {
      express: 49,
      'express delivery': 49,
      fixed: 249,
      'fixed time': 249,
      'fixed time delivery': 249,
      midnight: 349,
      'midnight delivery': 349,
      standard: 0,
      'standard delivery': 0,
      morning: 299,
      'morning delivery': 299,
      'next day': 0,
      'next day delivery': 0,
      remote: 0,
      'remote delivery': 0
    }
  };

  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const normalizeText = value => String(value || '').replace(/\s+/g, ' ').trim();
  const normalizeLower = value => normalizeText(value).toLowerCase();

  const normalizePrice = value => {
    if (value === null || value === undefined) return 0;

    const original = String(value);
    const raw = original
      .replace(/,/g, '')
      .replace(/[^\d.]/g, '')
      .trim();

    if (!raw) return 0;

    const parsed = Number(raw);

    if (!Number.isFinite(parsed)) return 0;

    if (!original.includes('.') && Number.isInteger(parsed) && parsed >= 10000) {
      return parsed / 100;
    }

    return parsed;
  };

  const readConfig = () => {
    const node = $('#OgAddonPopupConfig');

    if (!node) return DEFAULT_CONFIG;

    try {
      const userConfig = JSON.parse(node.textContent || '{}');

      return {
        ...DEFAULT_CONFIG,
        ...userConfig,
        deliveryFeeVariantByAmount: {
          ...FEE_VARIANT_BY_AMOUNT,
          ...(userConfig.deliveryFeeVariantByAmount || {})
        },
        deliveryFeeFallbackByType: {
          ...DEFAULT_CONFIG.deliveryFeeFallbackByType,
          ...(userConfig.deliveryFeeFallbackByType || {})
        }
      };
    } catch (error) {
      console.warn('[OG Addon] Invalid config JSON:', error);
      return DEFAULT_CONFIG;
    }
  };

  const config = readConfig();

  Object.keys(FEE_VARIANT_BY_AMOUNT).forEach(key => {
    if (!config.deliveryFeeVariantByAmount[key]) {
      config.deliveryFeeVariantByAmount[key] = FEE_VARIANT_BY_AMOUNT[key];
    }
  });

  const popup = $('#OgAddonPopup');
  if (!popup) return;

  if (!document.getElementById('OgAddonRequiredOptionStyle')) {
    const style = document.createElement('style');
    style.id = 'OgAddonRequiredOptionStyle';
    style.textContent = `
      .og-option-required-error {
        outline: 2px solid #d92d20 !important;
        outline-offset: 4px !important;
        border-radius: 10px !important;
      }
      .og-option-required-message {
        margin-top: 6px;
        color: #d92d20;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.35;
      }
    `;
    document.head.appendChild(style);
  }

  const els = {
    grid: $('[data-og-addon-grid]', popup),
    categories: $('[data-og-addon-categories]', popup),
    loading: $('[data-og-addon-loading]', popup),
    empty: $('[data-og-addon-empty]', popup),
    status: $('[data-og-addon-status]', popup),
    count: $('[data-og-addon-count]', popup),
    extra: $('[data-og-addon-extra]', popup),
    continueBtn: $('[data-og-addon-continue]', popup),
    skip: $('[data-og-addon-skip]', popup),
    back: $('[data-og-addon-back]', popup),
    senderName: $('[data-og-sender-name]', popup),
    senderPhone: $('[data-og-sender-phone]', popup),
    senderMessage: $('[data-og-sender-message]', popup),
    occasionButtons: $$('[data-og-occasion-id]', popup),
    occasionSelect: $('[data-og-occasion-select]', popup),
    suggestedWrap: $('[data-og-suggested-wrap]', popup),
    suggestedOpen: $('[data-og-suggested-open]', popup),
    messageModal: $('[data-og-message-modal]', popup),
    messageModalClose: $$('[data-og-message-modal-close]', popup),
    occasionMessages: $('[data-og-occasion-messages]', popup),
    occasionMessagesTitle: $('[data-og-occasion-messages-title]', popup),
    subtitle: $('[data-og-addon-subtitle]', popup)
  };

  const state = {
    activeForm: null,
    currentSlide: 'addons',
    currentProductVariantId: 0,
    currentProductHandle: '',
    products: [],
    categoryProducts: new Map(),
    categoryStatus: new Map(),
    activeCategoryKey: '',
    categoriesReady: false,
    categoriesLoading: false,
    addonVariantIds: new Set(),
    selected: new Map(),
    loaded: false,
    loading: false,
    adding: false,
    cleaning: false,
    selectedOccasionId: 0,
    deliverySync: {
      applying: false,
      sequence: 0,
      pending: null
    }
  };

  const shopifyRoutes = window.Shopify && window.Shopify.routes ? window.Shopify.routes : {};
  const root = shopifyRoutes.root || '/';
  const SENDER_STORAGE_KEY = 'og_addon_sender_details_v8';
  const DELIVERY_STORAGE_KEY = 'og_global_delivery_state_v1';
  const ADDON_SELECTION_STORAGE_KEY = 'og_addon_selection_v1';

  const apiUrl = path => {
    const cleanRoot = root.endsWith('/') ? root.slice(0, -1) : root;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${cleanRoot}${cleanPath}`;
  };

  const show = node => {
    if (node) node.hidden = false;
  };

  const hide = node => {
    if (node) node.hidden = true;
  };

  const unlockPage = () => {
    document.body.classList.remove('og-addon-lock');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'menu-opening');
    document.documentElement.classList.remove('overflow-hidden', 'menu-opening');

    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.documentElement.style.removeProperty('overflow');
  };

  const isAddonEnabledProductPage = () => {
    if (config.currentProductHasAddons === true) return true;
    if (config.currentProductIsExpress === true) return true;
    if (config.currentProductIsCourier === true) return true;

    const tags = Array.isArray(config.productTags)
      ? config.productTags.map(tag => normalizeLower(tag))
      : [];

    if (tags.includes('express') || tags.includes('courier')) return true;

    const bodyText = normalizeLower(document.body.textContent || '');

    if (bodyText.includes('tag: express') || bodyText.includes('tags: express')) return true;
    if (bodyText.includes('tag: courier') || bodyText.includes('tags: courier')) return true;

    return false;
  };

  const setStatus = (message = '', type = '') => {
    if (!els.status) return;

    els.status.textContent = message;
    els.status.className = 'og-addon__notice';

    if (type) {
      els.status.classList.add(`is-${type}`);
    }

    message ? show(els.status) : hide(els.status);
  };

  const formatMoney = value => {
    const amount = normalizePrice(value);
    return `${config.currencySymbol}${Math.round(amount).toLocaleString('en-IN')}`;
  };

  const escapeHtml = value => {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  };

  const getCurrentProductHandleFromUrl = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const getImage = product => {
    if (product.image && product.image.src) return product.image.src;

    if (Array.isArray(product.images) && product.images.length) {
      if (typeof product.images[0] === 'string') return product.images[0];
      return product.images[0].src || '';
    }

    return '';
  };

  const getAvailableVariant = product => {
    if (!Array.isArray(product.variants)) return null;
    return product.variants.find(variant => variant.available) || product.variants[0] || null;
  };

  const getProductPrice = product => {
    const variant = getAvailableVariant(product);
    return variant ? variant.price : product.price || 0;
  };

  const clearSenderErrors = () => {
    $$('[data-og-error-for]', popup).forEach(item => {
      item.textContent = '';
    });
  };

  const setSenderError = (key, message) => {
    const node = $(`[data-og-error-for="${key}"]`, popup);
    if (node) node.textContent = message;
  };

  const saveSenderDetails = () => {
    try {
      const payload = {
        expiresAt: Date.now() + (Number(config.senderStorageHours || 24) * 60 * 60 * 1000),
        values: {
          senderName: String(els.senderName?.value || '').trim(),
         senderPhone: String(els.senderPhone?.value || '').trim(),
          message: String(els.senderMessage?.value || '').trim()
        }
      };

      localStorage.setItem(SENDER_STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      console.warn('[OG Addon] Sender save skipped:', error);
    }
  };

  const loadSenderDetails = () => {
    try {
      const raw = localStorage.getItem(SENDER_STORAGE_KEY);
      if (!raw) return;

      const payload = JSON.parse(raw);

      if (!payload || !payload.expiresAt || Date.now() > Number(payload.expiresAt)) {
        localStorage.removeItem(SENDER_STORAGE_KEY);
        return;
      }

      const values = payload.values || {};

      if (els.senderName) els.senderName.value = values.senderName || '';
      if (els.senderPhone) els.senderPhone.value = values.senderPhone || '';
      if (els.senderMessage) els.senderMessage.value = values.message || '';
    } catch (error) {
      console.warn('[OG Addon] Sender load skipped:', error);
    }
  };



  let occasionMessagesCache = null;
  let occasionMessagesPromise = null;

  const getOccasionIndexById = id => {
    return OG_OCCASION_INDEX.find(item => Number(item.id) === Number(id)) || null;
  };

  const loadOccasionMessagesData = async () => {
    if (Array.isArray(occasionMessagesCache)) return occasionMessagesCache;
    if (occasionMessagesPromise) return occasionMessagesPromise;

    if (!config.occasionMessagesUrl) {
      throw new Error('Occasion messages URL is missing.');
    }

    occasionMessagesPromise = fetch(config.occasionMessagesUrl, {
      headers: { Accept: 'application/json' },
      cache: 'force-cache'
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Suggested messages could not be loaded.');
        }
        return response.json();
      })
      .then(data => {
        const list = Array.isArray(data) ? data : Array.isArray(data.occasions) ? data.occasions : [];
        occasionMessagesCache = list;
        return list;
      })
      .catch(error => {
        occasionMessagesPromise = null;
        throw error;
      });

    return occasionMessagesPromise;
  };

  const populateOccasionDropdown = () => {
    if (!els.occasionSelect) return;

    const currentValue = String(els.occasionSelect.value || '');
    const sorted = [...OG_OCCASION_INDEX].sort((a, b) =>
      a.name.localeCompare(b.name, 'en', { sensitivity: 'base' })
    );

    els.occasionSelect.innerHTML = '<option value="">More occasions</option>';

    sorted.forEach(item => {
      const option = document.createElement('option');
      option.value = String(item.id);
      option.textContent = item.name;
      els.occasionSelect.appendChild(option);
    });

    if (currentValue) els.occasionSelect.value = currentValue;
  };

  const closeSuggestedMessages = () => {
    if (!els.messageModal) return;

    els.messageModal.hidden = true;
    els.messageModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('og-addon-message-open');
    document.documentElement.classList.remove('og-addon-message-open');

    if (els.suggestedOpen && typeof els.suggestedOpen.focus === 'function') {
      window.setTimeout(() => els.suggestedOpen.focus(), 0);
    }
  };

  const selectOccasion = occasionId => {
    const occasionIndex = getOccasionIndexById(occasionId);
    state.selectedOccasionId = occasionIndex ? Number(occasionIndex.id) : 0;

    if (els.occasionButtons) {
      els.occasionButtons.forEach(button => {
        const active = Number(button.dataset.ogOccasionId) === state.selectedOccasionId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    if (els.suggestedWrap) {
      els.suggestedWrap.hidden = !occasionIndex;
    }

    if (els.suggestedOpen) {
      els.suggestedOpen.textContent = occasionIndex
        ? `Try one of our ${occasionIndex.name} Suggested Messages`
        : 'Try one of our Suggested Messages';
    }

    if (els.occasionMessagesTitle) {
      els.occasionMessagesTitle.textContent = occasionIndex
        ? `${occasionIndex.name} Suggested Messages`
        : 'Suggested Messages';
    }

    if (els.occasionMessages) {
      els.occasionMessages.innerHTML = '';
    }

    closeSuggestedMessages();
  };

  const openSuggestedMessages = async () => {
    const occasionIndex = getOccasionIndexById(state.selectedOccasionId);

    if (!occasionIndex || !els.messageModal || !els.occasionMessages) return;

    els.messageModal.hidden = false;
    els.messageModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('og-addon-message-open');
    document.documentElement.classList.add('og-addon-message-open');

    if (els.occasionMessagesTitle) {
      els.occasionMessagesTitle.textContent = `${occasionIndex.name} Suggested Messages`;
    }

    els.occasionMessages.innerHTML = '';

    const loading = document.createElement('p');
    loading.className = 'og-addon__message-empty';
    loading.textContent = 'Loading suggested messages...';
    els.occasionMessages.appendChild(loading);

    try {
      const allOccasions = await loadOccasionMessagesData();

      if (state.selectedOccasionId !== Number(occasionIndex.id)) return;

      const occasion = allOccasions.find(item => Number(item.id) === Number(occasionIndex.id));
      const messages = occasion && Array.isArray(occasion.messages) ? occasion.messages : [];

      els.occasionMessages.innerHTML = '';

      if (!messages.length) {
        const empty = document.createElement('p');
        empty.className = 'og-addon__message-empty';
        empty.textContent = 'No ready message is available for this occasion.';
        els.occasionMessages.appendChild(empty);
        return;
      }

      messages.forEach(message => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'og-addon__message-option';
        button.textContent = message;

        button.addEventListener('click', () => {
          if (els.senderMessage) {
            const maxLength = Number(els.senderMessage.maxLength || 300);
            els.senderMessage.value = String(message).slice(0, maxLength);
            els.senderMessage.dispatchEvent(new Event('input', { bubbles: true }));
            els.senderMessage.focus();
          }

          closeSuggestedMessages();
        });

        els.occasionMessages.appendChild(button);
      });
    } catch (error) {
      console.error('[OG Addon] Occasion messages load error:', error);
      els.occasionMessages.innerHTML = '';

      const failed = document.createElement('p');
      failed.className = 'og-addon__message-empty is-error';
      failed.textContent = 'Suggested messages could not be loaded. Please refresh once or type your own message.';
      els.occasionMessages.appendChild(failed);
    }
  };

  const renderOccasionMessages = occasionId => {
    selectOccasion(occasionId);
  };

  const resetSender = () => {
    loadSenderDetails();
    clearSenderErrors();
  };

  const setContinueText = text => {
    if (els.continueBtn) els.continueBtn.textContent = text;
  };

  const setSlide = slide => {
    state.currentSlide = slide;
    popup.classList.toggle('is-sender-step', slide === 'sender');

    $$('[data-og-slide]', popup).forEach(item => {
      item.classList.toggle('is-active', item.dataset.ogSlide === slide);
    });

    $$('[data-og-step-dot]', popup).forEach(dot => {
      dot.classList.toggle('is-active', dot.dataset.ogStepDot === (slide === 'addons' ? '1' : '2'));
    });

    setContinueText(slide === 'addons' ? 'CONTINUE' : 'CONTINUE');

    if (els.subtitle) {
      els.subtitle.textContent = slide === 'addons'
        ? 'Bring More Smiles to Their Celebration before checkout'
        : 'Add sender details before cart';
    }

    if (slide === 'sender') {
      window.setTimeout(() => {
        if (els.senderName) els.senderName.focus();
      }, 150);
    }
  };

  const getSelectedVariantId = form => {
    const input = form.querySelector('[name="id"]');
    return input ? Number(input.value) : 0;
  };

  const openPopup = async form => {
    state.activeForm = form;
    state.currentProductVariantId = getSelectedVariantId(form);
    state.currentProductHandle = getCurrentProductHandleFromUrl();

    setSlide('addons');
    updateSummary();
    setStatus('');

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('og-addon-lock');

    await loadProducts(true);
    restoreSelectedAddons();
    updateSelectedCards();
    updateSummary();
  };

  const closePopup = async options => {
    const opts = options || {};
    const shouldOpenCart = opts.openCart === true;

    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');

    state.activeForm = null;
    state.adding = false;

    unlockPage();

    if (shouldOpenCart && config.openCartDrawerOnPopupClose) {
      window.setTimeout(() => {
        openCartAfterAdd(false);
      }, 120);
    }
  };

  const getCollectionHandle = () => {
    if (config.collectionHandle) return String(config.collectionHandle).trim();

    if (config.currentProductIsCourier) return 'addons-courier';
    if (config.currentProductIsExpress) return 'addons';

    return '';
  };

  const getAddonCategories = () => {
    const configured = Array.isArray(config.addonCategories)
      ? config.addonCategories
      : [];

    const fallbackHandle = getCollectionHandle();
    const normalized = configured
      .map((item, index) => {
        const key = String(item?.key || `category-${index + 1}`).trim();
        const handle = String(item?.handle || '').trim();
        const title = String(item?.title || key).trim();
        const icon = String(item?.icon || key).trim().toLowerCase();

        // A category can be configured by handle OR by Shopify collection ID.
        if (!key || !title || !handle) return null;

        return { key, title, handle, icon };
      })
      .filter(Boolean);

    if (normalized.length) return normalized;

    return fallbackHandle
      ? [{ key: 'popular', title: 'Popular', handle: fallbackHandle, icon: 'popular' }]
      : [];
  };

  const categoryIconSvg = category => {
    const icon = normalizeLower(category?.icon || category?.key || 'popular');

    if (icon.includes('rakhi')) {
      return `
        <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
          <path d="M4 24h11M33 24h11" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
          <circle cx="24" cy="24" r="10" fill="none" stroke="currentColor" stroke-width="2.5"/>
          <circle cx="24" cy="24" r="4" fill="currentColor" opacity=".18"/>
          <path d="M24 14l2.7 5.2 5.8.8-4.2 4.1 1 5.8-5.3-2.8-5.3 2.8 1-5.8-4.2-4.1 5.8-.8L24 14z" fill="currentColor" opacity=".22"/>
        </svg>`;
    }

    if (icon.includes('flower')) {
      return `
        <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
          <circle cx="24" cy="24" r="4" fill="currentColor"/>
          <circle cx="24" cy="14" r="7" fill="none" stroke="currentColor" stroke-width="2"/>
          <circle cx="34" cy="24" r="7" fill="none" stroke="currentColor" stroke-width="2"/>
          <circle cx="24" cy="34" r="7" fill="none" stroke="currentColor" stroke-width="2"/>
          <circle cx="14" cy="24" r="7" fill="none" stroke="currentColor" stroke-width="2"/>
        </svg>`;
    }

    return `
      <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
        <rect x="10" y="11" width="28" height="26" rx="8" fill="none" stroke="currentColor" stroke-width="2.5"/>
        <path d="M24 16l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.6-4.8 2.6.9-5.4-3.9-3.8 5.4-.8L24 16z" fill="currentColor"/>
      </svg>`;
  };

  const mapRawProducts = rawProducts => {
    return rawProducts
      .map(product => {
        const variant = getAvailableVariant(product);

        if (!variant || !variant.available) return null;

        const variantId = Number(variant.id);
        state.addonVariantIds.add(variantId);

        return {
          id: Number(product.id),
          handle: String(product.handle || ''),
          title: product.title,
          image: getImage(product),
          variantId,
          price: getProductPrice(product),
          available: Boolean(variant.available)
        };
      })
      .filter(Boolean);
  };

  const fetchCollectionProducts = async (handle, customUrl = '') => {
    const products = [];
    const limit = Number(config.maxAddonsProductsToShow || 50);
    const perPage = 250;
    let page = 1;

    while (products.length < limit && page <= 4) {
      const useCustomUrl = customUrl && page === 1;
      const url = useCustomUrl
        ? `${customUrl}${customUrl.includes('?') ? '&' : '?'}limit=${perPage}&_=${Date.now()}`
        : apiUrl(`/collections/${encodeURIComponent(handle)}/products.json?limit=${perPage}&page=${page}&_=${Date.now()}`);

      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!response.ok) {
        const error = new Error(`Collection ${handle} is unavailable.`);
        error.status = response.status;
        throw error;
      }

      const data = await response.json();
      const batch = Array.isArray(data.products) ? data.products : [];

      if (!batch.length) break;
      products.push(...batch);
      if (batch.length < perPage) break;
      page += 1;
    }

    return products;
  };

  const renderCategoryTabs = () => {
    if (!els.categories) return;

    const categories = getAddonCategories();
    els.categories.innerHTML = '';

    categories.forEach(category => {
      const status = state.categoryStatus.get(category.key) || 'checking';
      const disabled = status !== 'active';
      const active = category.key === state.activeCategoryKey && !disabled;
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'og-addon__category';
      button.dataset.ogAddonCategory = category.key;
      button.disabled = disabled;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);
      button.classList.toggle('is-disabled', disabled);
      button.innerHTML = `
        <span class="og-addon__category-icon">${categoryIconSvg(category)}</span>
        <span class="og-addon__category-title">${escapeHtml(category.title)}</span>
      `;

      if (status === 'checking') {
        button.setAttribute('aria-label', `${category.title} collection checking`);
      } else if (disabled) {
        button.setAttribute('aria-label', `${category.title} collection unavailable`);
      }

      button.addEventListener('click', () => {
        if (button.disabled || category.key === state.activeCategoryKey) return;
        switchAddonCategory(category.key);
      });

      els.categories.appendChild(button);
    });

    els.categories.hidden = categories.length === 0;
  };

  const prepareAddonCategories = async force => {
    if (state.categoriesReady && !force) return;
    if (state.categoriesLoading) {
      while (state.categoriesLoading) {
        await new Promise(resolve => window.setTimeout(resolve, 25));
      }
      return;
    }

    state.categoriesLoading = true;
    state.categoriesReady = false;
    state.categoryProducts.clear();
    state.categoryStatus.clear();
    state.addonVariantIds.clear();

    // First resolve any category configured only with a Shopify collection ID.
    // This makes the tab title use the collection's real Shopify title and
    // then loads products from that collection's real handle.
    try {
    } catch (error) {
      console.warn('[OG Addon] Collection ID lookup failed:', error);
    }

    const categories = getAddonCategories();
    categories.forEach(category => state.categoryStatus.set(category.key, 'checking'));
    renderCategoryTabs();

    try {
      await Promise.all(categories.map(async category => {
        try {
          const customUrl = category.handle === getCollectionHandle()
            ? String(config.collectionProductsJsonUrl || '')
            : '';
          const rawProducts = await fetchCollectionProducts(category.handle, customUrl);
          const mapped = mapRawProducts(rawProducts);

          state.categoryProducts.set(category.key, mapped);
          state.categoryStatus.set(category.key, mapped.length ? 'active' : 'disabled');
        } catch (error) {
          console.warn(`[OG Addon] Category disabled: ${category.key}`, error);
          state.categoryProducts.set(category.key, []);
          state.categoryStatus.set(category.key, 'disabled');
        }
      }));

      const preferredKey = String(config.defaultAddonCategoryKey || 'popular');
      const preferred = categories.find(category =>
        category.key === preferredKey && state.categoryStatus.get(category.key) === 'active'
      );
      const firstActive = categories.find(category => state.categoryStatus.get(category.key) === 'active');

      if (!state.activeCategoryKey || state.categoryStatus.get(state.activeCategoryKey) !== 'active') {
        state.activeCategoryKey = preferred?.key || firstActive?.key || '';
      }

      state.categoriesReady = true;
      renderCategoryTabs();
    } finally {
      state.categoriesLoading = false;
    }
  };

  const switchAddonCategory = key => {
    const categoryKey = String(key || '');
    if (state.categoryStatus.get(categoryKey) !== 'active') return;

    state.activeCategoryKey = categoryKey;
    state.products = state.categoryProducts.get(categoryKey) || [];
    setStatus('');
    renderCategoryTabs();
    renderProducts();

    if (els.grid && typeof els.grid.scrollIntoView === 'function') {
      els.grid.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  const loadProducts = async forceRender => {
    if (state.loaded && !forceRender) return;
    if (state.loading) return;

    state.loading = true;
    show(els.loading);
    hide(els.empty);
    setStatus('');

    try {
      await prepareAddonCategories(Boolean(forceRender));

      if (!state.activeCategoryKey) {
        state.products = [];
        state.loaded = true;
        renderProducts();
        return;
      }

      state.products = state.categoryProducts.get(state.activeCategoryKey) || [];
      state.loaded = true;
      renderCategoryTabs();
      renderProducts();
    } catch (error) {
      console.error('[OG Addon] Product fetch error:', error);
      setStatus(error.message || 'Add-ons could not be loaded.', 'error');
    } finally {
      state.loading = false;
      hide(els.loading);
    }
  };

  const getFilteredAddonProducts = () => {
    const currentVariantId = Number(state.currentProductVariantId || 0);
    const currentHandle = String(state.currentProductHandle || '').trim();
    const limit = Math.max(0, Number(config.maxAddonsProductsToShow || 50));

    return state.products
      .filter(product => {
        if (!product || !product.variantId) return false;

        if (currentVariantId && Number(product.variantId) === currentVariantId) {
          return false;
        }

        if (currentHandle && String(product.handle || '') === currentHandle) {
          return false;
        }

        return true;
      })
      .slice(0, limit);
  };

  const renderProducts = () => {
    if (!els.grid) return;

    els.grid.innerHTML = '';

    const products = getFilteredAddonProducts();

    if (!products.length) {
      show(els.empty);
      updateSummary();
      return;
    }

    hide(els.empty);

    const badges = ['Best Seller', 'Best Seller', 'Best Seller', 'Best Seller'];

    products.forEach((product, index) => {
      const card = document.createElement('article');

      card.className = 'og-addon__card';
      card.dataset.variantId = String(product.variantId);

      card.innerHTML = `
        <div class="og-addon__image-wrap">
          ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
          ${index < 4 ? `<span class="og-addon__badge">${badges[index]}</span>` : ''}
        </div>

        <div class="og-addon__info">
          <h3 class="og-addon__title">${escapeHtml(product.title)}</h3>

          <div class="og-addon__meta">
            <strong class="og-addon__price">${formatMoney(product.price)}</strong>
            <button class="og-addon__select" type="button" aria-pressed="false">Add</button>
          </div>
        </div>
      `;

      card.addEventListener('click', event => {
        event.preventDefault();
        toggleAddon(product);
      });

      els.grid.appendChild(card);
    });

    updateSelectedCards();
    updateSummary();
  };

  const getAddonSelectionScope = () => {
    if (config.currentProductIsCourier || normalizeLower(config.addonSource).includes('courier')) {
      return 'courier';
    }

    return 'express';
  };

  const saveSelectedAddons = () => {
    try {
      const raw = localStorage.getItem(ADDON_SELECTION_STORAGE_KEY);
      const stored = raw ? JSON.parse(raw) : {};
      const payload = stored && typeof stored === 'object' ? stored : {};

      payload[getAddonSelectionScope()] = Array.from(state.selected.keys())
        .map(Number)
        .filter(Number.isFinite);

      localStorage.setItem(ADDON_SELECTION_STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      console.warn('[OG Addon] Add-on selection save skipped:', error);
    }
  };

  const restoreSelectedAddons = () => {
    try {
      const raw = localStorage.getItem(ADDON_SELECTION_STORAGE_KEY);
      if (!raw) return;

      const stored = JSON.parse(raw);
      const savedIds = Array.isArray(stored?.[getAddonSelectionScope()])
        ? stored[getAddonSelectionScope()].map(Number).filter(Number.isFinite)
        : [];

      const allAvailableProducts = state.categoryProducts.size
        ? Array.from(state.categoryProducts.values()).flat()
        : state.products;

      const availableByVariant = new Map(
        allAvailableProducts.map(product => [Number(product.variantId), product])
      );

      state.selected.clear();

      savedIds.slice(0, Number(config.maxAddonsSelectable || savedIds.length)).forEach(variantId => {
        const product = availableByVariant.get(variantId);
        if (product && product.available !== false) {
          state.selected.set(variantId, product);
        }
      });

      // Remove stale or unavailable variant IDs from storage automatically.
      saveSelectedAddons();
    } catch (error) {
      console.warn('[OG Addon] Add-on selection restore skipped:', error);
    }
  };

  const clearSelectedAddons = () => {
    state.selected.clear();
    saveSelectedAddons();
    updateSelectedCards();
    updateSummary();
  };

  const toggleAddon = product => {
    const id = Number(product.variantId);

    if (state.selected.has(id)) {
      state.selected.delete(id);
    } else {
      if (
        Number(config.maxAddonsSelectable) > 0 &&
        state.selected.size >= Number(config.maxAddonsSelectable)
      ) {
        setStatus(`Maximum ${config.maxAddonsSelectable} add-ons can be selected.`, 'error');
        return;
      }

      state.selected.set(id, product);
    }

    saveSelectedAddons();
    setStatus('');
    updateSelectedCards();
    updateSummary();
  };

  const updateSelectedCards = () => {
    $$('.og-addon__card', popup).forEach(card => {
      const variantId = Number(card.dataset.variantId);
      const selected = state.selected.has(variantId);
      const button = $('.og-addon__select', card);

      card.classList.toggle('is-selected', selected);

      if (button) {
        button.textContent = selected ? 'Added ✓' : '+ Add';
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }
    });
  };

  const updateSummary = () => {
    const count = state.selected.size;

    const total = Array.from(state.selected.values()).reduce((sum, item) => {
      return sum + normalizePrice(item.price);
    }, 0);

    if (els.count) {
      els.count.textContent = `${count} Add-on${count === 1 ? '' : 's'} Selected`;
    }

    if (els.extra) {
      els.extra.textContent = `Extra ${formatMoney(total)}`;
    }

    /*
      Footer behaviour:
      - 0 selected: Skip visible + CONTINUE
      - 1+ selected: Skip hidden + CONTINUE WITH N ADDON(S)
      - has-addon-selection lets mobile CSS make Continue full width.
    */
    if (els.skip) {
      const hideSkip = count > 0;
      els.skip.hidden = hideSkip;
      els.skip.setAttribute('aria-hidden', hideSkip ? 'true' : 'false');
    }

    if (els.continueBtn && state.currentSlide === 'addons' && !state.adding) {
      els.continueBtn.textContent = count > 0
        ? `CONTINUE WITH ${count} ADDON${count === 1 ? '' : 'S'}`
        : 'CONTINUE';
    }

    popup.classList.toggle('has-addon-selection', count > 0);
  };

  const isCodeLikeText = value => {
    return /localStorage|getItem|setItem|function|=>|const |let |var |return |if\s*\(|document\.|window\.|\{|\}/i.test(String(value || ''));
  };

  const cleanValue = value => {
    let text = normalizeText(value);

    if (!text || isCodeLikeText(text)) return '';

    text = text
      .replace(/^[\s:.-]+/, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!text || isCodeLikeText(text)) return '';

    return text;
  };

  const addPropIfFilled = (props, key, value) => {
    const cleanKey = String(key || '').trim();
    const cleanVal = cleanValue(value);

    if (!cleanKey || !cleanVal) return;

    props[cleanKey] = cleanVal;
  };

  const getLineItemPropertiesFromScope = scope => {
    const properties = {};

    if (!scope) return properties;

    const formData = scope.tagName === 'FORM' ? new FormData(scope) : null;

    if (formData) {
      for (const [name, value] of formData.entries()) {
        const match = String(name).match(/^properties\[(.+)]$/);

        if (!match) continue;

        addPropIfFilled(properties, match[1], value);
      }
    }

    $$('[data-og-property-name]', scope).forEach(input => {
      addPropIfFilled(properties, input.dataset.ogPropertyName, input.value);
    });

    $$('[name^="properties["]', scope).forEach(input => {
      const match = String(input.name || '').match(/^properties\[(.+)]$/);
      if (!match) return;

      addPropIfFilled(properties, match[1], input.value);
    });

    return properties;
  };

  const readValueBySelectors = selectors => {
    for (const selector of selectors) {
      const node = document.querySelector(selector);

      if (!node) continue;

      const value =
        node.value ||
        node.getAttribute('value') ||
        node.dataset.value ||
        node.textContent ||
        '';

      const clean = cleanValue(value);

      if (clean || clean === '0') return clean;
    }

    return '';
  };

  const getSummaryText = () => {
    const nodes = $$(
      '.og-selected-delivery, [data-og-selected-delivery], .og-delivery-summary, .og-delivery-selected, [class*="selected"][class*="delivery"], [class*="delivery"][class*="summary"], #ogDeliveryWidget, .og-delivery-widget'
    );

    return nodes
      .map(node => normalizeText(node.textContent || ''))
      .filter(Boolean)
      .join(' | ');
  };

  const extractByLabel = (text, label) => {
    const raw = normalizeText(text);
    if (!raw) return '';

    const labels = [
      'Delivery City',
      'Delivery Pincode',
      'Delivery Date',
      'Delivery Type',
      'Delivery Slot',
      'Delivery Charge',
      'Delivery Fee',
      'Final Delivery Charge',
      'Remote Charge',
      'Sender Name',
      'Sender Phone Number',
      'Message with Order'
    ];

    const escapedLabel = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const otherLabels = labels
      .filter(item => item !== label)
      .map(item => item.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|');

    const regex = new RegExp(`${escapedLabel}\\s*:?\\s*(.*?)(?=\\s*(?:${otherLabels})\\s*:?|$)`, 'i');
    const match = raw.match(regex);

    if (!match || !match[1]) return '';

    return cleanValue(match[1]);
  };

  const cleanDateText = value => {
    let text = cleanValue(value);

    if (!text) return '';

    text = text
      .replace(/^Delivery Date\s*:?\s*/i, '')
      .replace(/\bDelivery Type\b.*$/i, '')
      .replace(/\bDelivery Slot\b.*$/i, '')
      .replace(/\bDelivery Charge\b.*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!text || isCodeLikeText(text)) return '';

    const ddmmyyyy = text.match(/\b\d{1,2}[-/]\d{1,2}[-/]\d{2,4}\b/);
    if (ddmmyyyy) return ddmmyyyy[0];

    const todayTomorrow = text.match(/\b(Today|Tomorrow)\b[\s,]*(Mon|Tue|Wed|Thu|Fri|Sat|Sun)?[\s,]*\d{1,2}[\s,]*(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)?/i);
    if (todayTomorrow) return normalizeText(todayTomorrow[0]);

    const monthDate = text.match(/\b\d{1,2}\s*(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s*,?\s*\d{2,4}?\b/i);
    if (monthDate) return normalizeText(monthDate[0]);

    return text.length <= 40 ? text : '';
  };

  const cleanDeliveryTypeText = text => {
    const clean = normalizeText(text);

    if (/morning/i.test(clean)) return 'Morning Delivery';
    if (/express/i.test(clean)) return 'Express Delivery';
    if (/standard/i.test(clean)) return 'Standard Delivery';
    if (/fixed/i.test(clean)) return 'Fixed Time Delivery';
    if (/midnight/i.test(clean)) return 'Midnight Delivery';
    if (/remote/i.test(clean)) return 'Remote Delivery';
    if (/next/i.test(clean)) return 'Next Day Delivery';

    return cleanValue(clean);
  };

  const cleanSlotText = text => {
    const clean = cleanValue(text);
    if (!clean) return '';

    const range1 = clean.match(/\b\d{1,2}:\d{2}\s*(AM|PM)\s*[-–]\s*\d{1,2}:\d{2}\s*(AM|PM)\b/i);
    if (range1) return normalizeText(range1[0]);

    const range2 = clean.match(/\b\d{1,2}\s*(AM|PM)\s*[-–]\s*\d{1,2}\s*(AM|PM)\b/i);
    if (range2) return normalizeText(range2[0]);

    const single = clean.match(/\b\d{1,2}:\d{2}\s*(AM|PM)\b/i);
    if (single) return normalizeText(single[0]);

    return clean;
  };

  const getSelectedLocation = () => {
    const directCity = readValueBySelectors([
      '[name="properties[Delivery City]"]',
      '[data-og-property-name="Delivery City"]'
    ]);

    const directPin = readValueBySelectors([
      '[name="properties[Delivery Pincode]"]',
      '[data-og-property-name="Delivery Pincode"]'
    ]);

    const summaryText = getSummaryText();

    const cityFromSummary = extractByLabel(summaryText, 'Delivery City');
    const pinFromSummary = extractByLabel(summaryText, 'Delivery Pincode');

    const rawLocation = readValueBySelectors([
      '#ogLocationInput',
      '[data-og-location-input]',
      '.og-location-input',
      '.og-delivery-location input',
      '.og-delivery-widget input[type="text"]',
      '.og-delivery-widget input[type="search"]',
      '.og-delivery-widget input[type="tel"]',
      'input[placeholder*="pincode" i]',
      'input[placeholder*="city" i]',
      'input[placeholder*="location" i]'
    ]);

    const result = {
      city: directCity || cityFromSummary || '',
      pincode: directPin || pinFromSummary || ''
    };

    const source = `${directCity} ${directPin} ${summaryText} ${rawLocation}`;
    const pinMatch = source.match(/\b\d{6}\b/);

    if (!result.pincode && pinMatch) {
      result.pincode = pinMatch[0];
    }

    if (!result.city && rawLocation) {
      result.city = rawLocation
        .replace(/\b\d{6}\b/g, '')
        .replace(/[,|-]/g, ' ')
        .replace(/\bIND\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    return result;
  };

  const getSelectedDateText = () => {
    const hiddenValue = readValueBySelectors([
      '[name="properties[Delivery Date]"]',
      '[data-og-property-name="Delivery Date"]',
      '[data-og-delivery-date]'
    ]);

    const cleanHidden = cleanDateText(hiddenValue);
    if (cleanHidden) return cleanHidden;

    const summaryText = getSummaryText();
    const fromSummary = cleanDateText(extractByLabel(summaryText, 'Delivery Date'));
    if (fromSummary) return fromSummary;

    const selectedDateNode = document.querySelector(
      '.og-date-card.is-selected, .og-date-card.selected, .og-delivery-date .is-selected, .og-delivery-date [aria-pressed="true"], .og-delivery-date [aria-selected="true"], [class*="date"] .is-selected, [class*="date"] [aria-pressed="true"]'
    );

    if (selectedDateNode) {
      const cleanSelected = cleanDateText(selectedDateNode.textContent || selectedDateNode.value || '');
      if (cleanSelected) return cleanSelected;
    }

    return '';
  };

  const getSelectedDeliveryType = () => {
    const direct = readValueBySelectors([
      '[name="properties[Delivery Type]"]',
      '[data-og-property-name="Delivery Type"]',
      '[data-og-delivery-type]'
    ]);

    if (direct) return cleanDeliveryTypeText(direct);

    const summaryText = getSummaryText();
    const fromSummary = extractByLabel(summaryText, 'Delivery Type');
    if (fromSummary) return cleanDeliveryTypeText(fromSummary);

    const checked =
      document.querySelector('.og-delivery_type-slot-grid input:checked') ||
      document.querySelector('.og-delivery-type-slot-grid input:checked') ||
      document.querySelector('.og-slot-card__radio:checked') ||
      document.querySelector('input[name*="Delivery Type"]:checked') ||
      document.querySelector('input[name*="delivery_type"]:checked') ||
      document.querySelector('input[name*="delivery-type"]:checked');

    if (checked) {
      const card = checked.closest('label, .og-slot-card, .delivery-option, .product-form__input, [class*="delivery"]');
      const text = normalizeText(card ? card.textContent : checked.value);
      return cleanDeliveryTypeText(text);
    }

    return '';
  };

  const getSelectedDeliverySlot = () => {
    const direct = readValueBySelectors([
      '[name="properties[Delivery Slot]"]',
      '[data-og-property-name="Delivery Slot"]',
      '[data-og-delivery-slot]'
    ]);

    if (direct) return cleanSlotText(direct);

    const summaryText = getSummaryText();
    const fromSummary = extractByLabel(summaryText, 'Delivery Slot');
    if (fromSummary) return cleanSlotText(fromSummary);

    const checked =
      document.querySelector('#ogSlotOptions input:checked') ||
      document.querySelector('.og-slot-options input:checked') ||
      document.querySelector('.og-delivery-slot input:checked') ||
      document.querySelector('input[name*="Delivery Slot"]:checked') ||
      document.querySelector('input[name*="delivery_slot"]:checked') ||
      document.querySelector('input[name*="delivery-slot"]:checked');

    if (checked) {
      const card = checked.closest('label, .og-slot-card, .delivery-slot, .product-form__input, [class*="slot"]');
      return cleanSlotText(card ? card.textContent : checked.value);
    }

    return '';
  };

  const getDatasetNumber = node => {
    if (!node || !node.dataset) return 0;

    const keys = [
      'ogSelectedDeliveryFeeAmount',
      'ogDeliveryFee',
      'ogDeliveryCharge',
      'ogDeliveryAmount',
      'deliveryFee',
      'deliveryCharge',
      'deliveryAmount',
      'fee',
      'charge',
      'amount',
      'price'
    ];

    for (const key of keys) {
      if (node.dataset[key] === undefined) continue;

      const amount = Math.round(normalizePrice(node.dataset[key]));

      if (amount > 0) return amount;
    }

    return 0;
  };

  const getSelectedDeliveryCard = () => {
    return (
      document.querySelector('.og-slot-card.is-selected') ||
      document.querySelector('.og-slot-card.selected') ||
      document.querySelector('.og-delivery-option.is-selected') ||
      document.querySelector('.og-delivery-option.selected') ||
      document.querySelector('.og-delivery-card.is-selected') ||
      document.querySelector('.og-delivery-card.selected') ||
      document.querySelector('[data-og-delivery-type].is-selected') ||
      document.querySelector('[data-og-delivery-type].selected') ||
      document.querySelector('[class*="delivery"] [aria-pressed="true"]') ||
      document.querySelector('[class*="delivery"] [aria-selected="true"]') ||
      document.querySelector('.og-delivery_type-slot-grid input:checked')?.closest('label, .og-slot-card, .og-delivery-option, .og-delivery-card, [class*="delivery"]') ||
      document.querySelector('.og-delivery-type-slot-grid input:checked')?.closest('label, .og-slot-card, .og-delivery-option, .og-delivery-card, [class*="delivery"]') ||
      document.querySelector('#ogSlotOptions input:checked')?.closest('label, .og-slot-card, .og-delivery-option, .og-delivery-card, [class*="delivery"]') ||
      document.querySelector('.og-slot-options input:checked')?.closest('label, .og-slot-card, .og-delivery-option, .og-delivery-card, [class*="delivery"]') ||
      null
    );
  };

  const getAmountFromText = text => {
    const clean = normalizeText(text || '');

    if (!clean) return 0;

    if (/free/i.test(clean)) return 0;

    const rupeeMatches = clean.match(/₹\s*([0-9,]+)/g);

    if (rupeeMatches && rupeeMatches.length) {
      const last = rupeeMatches[rupeeMatches.length - 1];
      const amount = Math.round(normalizePrice(last));

      if (amount > 0) return amount;
    }

    const chargeMatch = clean.match(/(?:delivery\s*(?:charge|fee)|final\s*delivery\s*charge|remote\s*charge|extra|charge|fee)\s*:?\s*₹?\s*([0-9,]+)/i);

    if (chargeMatch && chargeMatch[1]) {
      const amount = Math.round(normalizePrice(chargeMatch[1]));

      if (amount > 0) return amount;
    }

    return 0;
  };

  const getAmountFromDeliveryTypeFallback = () => {
    const typeText = normalizeLower(getSelectedDeliveryType());
    const fallback = config.deliveryFeeFallbackByType || {};

    if (!typeText) return 0;

    const entries = Object.entries(fallback).sort((a, b) => b[0].length - a[0].length);

    for (const [key, value] of entries) {
      const cleanKey = normalizeLower(key);

      if (cleanKey && typeText.includes(cleanKey)) {
        return Math.round(Number(value || 0));
      }
    }

    if (typeText.includes('midnight')) return 349;
    if (typeText.includes('fixed')) return 249;
    if (typeText.includes('morning')) return 299;
    if (typeText.includes('express')) return 49;
    if (typeText.includes('standard')) return 0;

    if (typeText.includes('remote')) return 0;
    if (typeText.includes('next')) return 0;

    return 0;
  };

  const getDeliveryFeeAmountFromPage = () => {
    const forcedAmount = readValueBySelectors([
      '[name="properties[_og_selected_delivery_fee_amount]"]',
      '[name="properties[_og_delivery_fee_amount]"]',
      '[name="properties[Delivery Charge]"]',
      '[name="properties[Delivery Fee]"]',
      '[name="properties[Final Delivery Charge]"]',
      '[name="properties[Remote Charge]"]',
      '#OgSelectedDeliveryFeeAmount',
      '[data-og-selected-delivery-fee-amount]',
      '[data-og-delivery-charge]',
      '[data-og-delivery-fee]',
      '[data-og-delivery-amount]',
      '[data-delivery-charge]',
      '[data-delivery-fee]',
      '[data-delivery-amount]'
    ]);

    if (forcedAmount || forcedAmount === '0') {
      const amount = Math.round(normalizePrice(forcedAmount));

      if (amount >= 0) return amount;
    }

    const selectedCard = getSelectedDeliveryCard();

    if (selectedCard) {
      const cardText = normalizeText(selectedCard.textContent || '');

      if (/free|standard/i.test(cardText)) return 0;

      const datasetAmount = getDatasetNumber(selectedCard);
      if (datasetAmount > 0) return datasetAmount;

      const input = selectedCard.querySelector('input:checked, input[type="radio"], input[type="hidden"]');

      if (input) {
        const inputDatasetAmount = getDatasetNumber(input);

        if (inputDatasetAmount > 0) return inputDatasetAmount;

        const inputValueAmount = getAmountFromText(input.value || '');

        if (inputValueAmount > 0) return inputValueAmount;
      }

      const cardAmountMatch = cardText.match(/₹\s*([0-9,]+)/);

      if (cardAmountMatch && cardAmountMatch[1]) {
        const amount = Math.round(normalizePrice(cardAmountMatch[1]));
        if (amount > 0) return amount;
      }

      const cardTextAmount = getAmountFromText(cardText);

      if (cardTextAmount > 0) return cardTextAmount;
    }

    const summaryText = getSummaryText();

    const labeledValues = [
      extractByLabel(summaryText, 'Delivery Charge'),
      extractByLabel(summaryText, 'Delivery Fee'),
      extractByLabel(summaryText, 'Final Delivery Charge'),
      extractByLabel(summaryText, 'Remote Charge')
    ];

    for (const value of labeledValues) {
      const amount = getAmountFromText(value);
      if (amount > 0) return amount;
    }

    const summaryAmount = getAmountFromText(summaryText);

    if (summaryAmount > 0) return summaryAmount;

    return getAmountFromDeliveryTypeFallback();
  };

  const getDeliveryFeeVariantId = amount => {
    const map = config.deliveryFeeVariantByAmount || {};
    const cleanAmount = String(Math.round(Number(amount || 0)));

    if (map[cleanAmount]) return Number(map[cleanAmount]);

    const numericKeys = Object.keys(map)
      .map(key => Number(key))
      .filter(num => Number.isFinite(num));

    const exact = numericKeys.find(num => Number(num) === Number(cleanAmount));

    if (exact !== undefined && map[String(exact)]) return Number(map[String(exact)]);

    return 0;
  };

  const getDeliveryPropertiesFromPage = () => {
    const props = {};

    const formProps = getLineItemPropertiesFromScope(state.activeForm);

    [
      'Delivery City',
      'Delivery Pincode',
      'Delivery Date',
      'Delivery Type',
      'Delivery Slot'
    ].forEach(key => {
      if (formProps[key]) props[key] = formProps[key];
    });

    const location = getSelectedLocation();

    if (!props['Delivery City'] && location.city) {
      props['Delivery City'] = location.city;
    }

    if (!props['Delivery Pincode'] && location.pincode) {
      props['Delivery Pincode'] = location.pincode;
    }

    const dateText = cleanDateText(props['Delivery Date']) || getSelectedDateText();

    if (dateText) {
      props['Delivery Date'] = dateText;
    } else {
      delete props['Delivery Date'];
    }

    const typeText = cleanDeliveryTypeText(props['Delivery Type']) || getSelectedDeliveryType();

    if (typeText) {
      props['Delivery Type'] = typeText;
    } else {
      delete props['Delivery Type'];
    }

    const slotText = cleanSlotText(props['Delivery Slot']) || getSelectedDeliverySlot();

    if (slotText) {
      props['Delivery Slot'] = slotText;
    } else {
      delete props['Delivery Slot'];
    }

    return props;
  };

  const validateDeliverySelection = () => {
    if (!config.requireDeliverySelection) return true;
    if (config.currentProductIsCourier) return true;

    const deliveryProps = getDeliveryPropertiesFromPage();

    if (
      deliveryProps['Delivery City'] ||
      deliveryProps['Delivery Pincode'] ||
      deliveryProps['Delivery Date'] ||
      deliveryProps['Delivery Type'] ||
      deliveryProps['Delivery Slot']
    ) {
      return true;
    }

    const firstDeliveryArea =
      document.querySelector('.og-delivery-widget, #ogDeliveryWidget') ||
      document.querySelector('[class*="delivery"]');

    if (firstDeliveryArea && typeof firstDeliveryArea.scrollIntoView === 'function') {
      firstDeliveryArea.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    alert('Please select delivery date and time slot first.');
    return false;
  };

  const validateOptisRequiredOptions = form => {
    if (!config.requireOptisRequiredOptions) return true;

    const scope =
      form?.closest('.product, .product__info-wrapper, .product__info-container, [id*="MainProduct"], main') ||
      document.querySelector('.product, .product__info-wrapper, .product__info-container, [id*="MainProduct"]') ||
      document;

    const clean = value => String(value || '').replace(/\s+/g, ' ').trim();

    const cssEscapeSafe = value => {
      if (window.CSS && CSS.escape) return CSS.escape(value);
      return String(value || '').replace(/["\\]/g, '\\$&');
    };

    const isNodeVisible = el => {
      if (!el) return false;

      if (
        el.closest('[hidden], [aria-hidden="true"], #OgAddonPopup, .og-addon, #CartDrawer, cart-drawer, header, footer')
      ) {
        return false;
      }

      const style = window.getComputedStyle(el);
      if (!style || style.display === 'none' || style.visibility === 'hidden') return false;

      const rect = el.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0;
    };

    const getWrapper = field => {
      return (
        field.closest(
          '.po-group, .po-option, .po-option-field, .po-field, .product-option, .product-form__input, .field, .form-field, [data-option-group], [data-po-group], [class*="option"], [class*="upload"]'
        ) ||
        field.parentElement ||
        field
      );
    };

    const getLabelText = field => {
      if (!field) return '';

      if (field.id) {
        const label = document.querySelector(`label[for="${cssEscapeSafe(field.id)}"]`);
        if (label && clean(label.textContent)) return clean(label.textContent);
      }

      const wrapper = getWrapper(field);

      const labelNode = wrapper.querySelector?.(
        'label, legend, .po-label, .po-title, .po-option-label, .form__label, [class*="label"], [class*="title"]'
      );

      if (labelNode && clean(labelNode.textContent)) return clean(labelNode.textContent);

      return clean(wrapper.textContent || field.placeholder || field.name || '');
    };

    const getPropertyName = field => {
      const match = String(field.name || '').match(/properties\[(.+)]/i);
      return match && match[1] ? clean(match[1]) : '';
    };

    const shouldIgnore = field => {
      const type = String(field.type || '').toLowerCase();
      const name = String(field.name || '').toLowerCase();
      const id = String(field.id || '').toLowerCase();
      const cls = String(field.className || '').toLowerCase();
      const placeholder = String(field.placeholder || '').toLowerCase();

      if (field.disabled || field.readOnly) return true;
      if (['submit', 'button', 'reset'].includes(type)) return true;
      if (['id', 'quantity', 'selling_plan', 'form_type', 'utf8'].includes(name)) return true;

      if (
        name.includes('delivery') ||
        id.includes('delivery') ||
        cls.includes('delivery') ||
        placeholder.includes('city') ||
        placeholder.includes('pincode') ||
        placeholder.includes('location') ||
        placeholder.includes('search') ||
        name.includes('sender') ||
        name.includes('message')
      ) {
        return true;
      }

      if (
        field.closest('#OgAddonPopup') ||
        field.closest('.og-addon') ||
        field.closest('#CartDrawer') ||
        field.closest('cart-drawer') ||
        field.closest('header') ||
        field.closest('footer') ||
        field.closest('[class*="search"]')
      ) {
        return true;
      }

      return false;
    };

    const isRequiredField = field => {
      if (!field || shouldIgnore(field)) return false;

      const type = String(field.type || '').toLowerCase();
      const wrapper = getWrapper(field);

      if (type !== 'file' && type !== 'hidden' && !isNodeVisible(field)) return false;
      if ((type === 'file' || type === 'hidden') && !isNodeVisible(wrapper)) return false;

      const labelText = getLabelText(field);
      const wrapperText = clean(wrapper?.textContent || '');
      const propName = getPropertyName(field);

      if (
        field.required ||
        field.getAttribute('aria-required') === 'true' ||
        field.getAttribute('data-required') === 'true' ||
        field.getAttribute('data-is-required') === 'true' ||
        field.getAttribute('data-po-required') === 'true'
      ) {
        return true;
      }

      if (
        labelText.includes('*') ||
        wrapperText.includes('*') ||
        /\brequired\b/i.test(labelText) ||
        /\brequired\b/i.test(wrapperText)
      ) {
        return true;
      }

      if (
        /^properties\[/i.test(String(field.name || '')) &&
        propName &&
        !/delivery|sender|message/i.test(propName)
      ) {
        return true;
      }

      return false;
    };

    const isBlankField = field => {
      const type = String(field.type || '').toLowerCase();
      const tag = String(field.tagName || '').toLowerCase();
      const wrapper = getWrapper(field);

      if (type === 'radio' || type === 'checkbox') {
        const groupScope = field.closest('form') || scope;

        if (field.name) {
          return !groupScope.querySelector(`[name="${cssEscapeSafe(field.name)}"]:checked`);
        }

        return !field.checked;
      }

      if (type === 'file') {
        if (field.files && field.files.length > 0) return false;

        const uploadedText = clean(wrapper.textContent || '');

        if (
          /uploaded|selected|remove|change|replace|file selected|image selected/i.test(uploadedText) &&
          !/choose file|drop file to upload|or drop file|no file/i.test(uploadedText)
        ) {
          return false;
        }

        const preview =
          wrapper.querySelector('img[src]:not([src=""])') ||
          wrapper.querySelector('[class*="preview"]') ||
          wrapper.querySelector('[class*="uploaded"]') ||
          wrapper.querySelector('[data-file], [data-uploaded], [data-preview]');

        if (preview) return false;

        return true;
      }

      if (tag === 'select') {
        return !clean(field.value);
      }

      if (type === 'hidden') {
        const val = clean(field.value);

        if (val) return false;

        const uploadedText = clean(wrapper.textContent || '');

        if (
          /uploaded|selected|remove|change|replace|file selected|image selected/i.test(uploadedText) &&
          !/choose file|drop file to upload|or drop file|no file/i.test(uploadedText)
        ) {
          return false;
        }

        const fileInput = wrapper.querySelector('input[type="file"]');
        if (fileInput && fileInput.files && fileInput.files.length > 0) return false;

        const preview =
          wrapper.querySelector('img[src]:not([src=""])') ||
          wrapper.querySelector('[class*="preview"]') ||
          wrapper.querySelector('[class*="uploaded"]') ||
          wrapper.querySelector('[data-file], [data-uploaded], [data-preview]');

        if (preview) return false;

        return true;
      }

      return !clean(field.value);
    };

    const showError = field => {
      const wrapper = getWrapper(field);

      wrapper.classList.add('og-option-required-error');

      if (!wrapper.querySelector('.og-option-required-message')) {
        const msg = document.createElement('div');
        msg.className = 'og-option-required-message';
        msg.textContent = 'Please fill this required option.';
        wrapper.appendChild(msg);
      }

      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      if (String(field.type || '').toLowerCase() !== 'hidden') {
        setTimeout(() => {
          try {
            field.focus({ preventScroll: true });
          } catch (error) {
            if (typeof field.focus === 'function') field.focus();
          }
        }, 200);
      }

      setTimeout(() => {
        wrapper.classList.remove('og-option-required-error');
      }, 3000);
    };

    const requiredFields = Array.from(scope.querySelectorAll('input, textarea, select'))
      .filter(isRequiredField);

    for (const field of requiredFields) {
      if (!isBlankField(field)) continue;

      const label = getLabelText(field)
        .replace(/\*/g, '')
        .replace(/\brequired\b/ig, '')
        .replace(/choose file/ig, '')
        .replace(/or drop file to upload/ig, '')
        .trim();

      showError(field);

      alert(`Please fill required option${label ? `: ${label}` : ''}`);

      return false;
    }

    return true;
  };

  const validateProductForm = form => {
    if (!form) return false;

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') {
        form.reportValidity();
      }

      return false;
    }

    const variantInput = form.querySelector('[name="id"]');

    if (!variantInput || !variantInput.value) {
      alert('Please select product option first.');
      return false;
    }

    if (!validateOptisRequiredOptions(form)) {
      return false;
    }

    if (!validateDeliverySelection()) {
      return false;
    }

    return true;
  };

  const validateSender = () => {
    clearSenderErrors();

    const name = String(els.senderName?.value || '').trim();
   const phone = String(els.senderPhone?.value || '').trim();
    const message = String(els.senderMessage?.value || '').trim();

    let valid = true;

    if (config.requireSenderName && name.length < 2) {
      setSenderError('sender_name', 'Please enter sender name.');
      valid = false;
    }

    // Phone is visually marked “*Required” only. It is never technically required
    // and never blocks Add to Cart, Buy Now or Checkout when blank or incomplete.

    if (config.requireMessage && message.length < 2) {
      setSenderError('message', 'Please enter your message.');
      valid = false;
    }

    return {
      valid,
      values: {
        senderName: name,
        senderPhone: phone,
        message
      }
    };
  };

  const getQuantity = form => {
    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);

    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  };

  const getSellingPlan = form => {
    const input = form.querySelector('[name="selling_plan"]');
    return input && input.value ? input.value : null;
  };

  const getAllParentProperties = (form, deliveryMode) => {
    const properties = { ...getLineItemPropertiesFromScope(form) };

    if (deliveryMode === 'express') {
      Object.assign(properties, getDeliveryPropertiesFromPage());
    } else {
      DELIVERY_PROPERTY_KEYS.forEach(key => delete properties[key]);
    }

    return properties;
  };

  const getParentTitle = () => {
    const titleNode =
      $('[data-product-title]') ||
      $('.product__title') ||
      $('h1');

    return titleNode
      ? titleNode.textContent.trim()
      : document.title.replace(/\s*[-|].*$/, '').trim();
  };

  const postJson = async (url, payload) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message = data.description || data.message || 'Something went wrong.';
      throw new Error(message);
    }

    return data;
  };

  const DELIVERY_PROPERTY_KEYS = [
    'Delivery City',
    'Delivery Pincode',
    'Delivery Date',
    'Delivery Type',
    'Delivery Slot',
    'Delivery Charge',
    'Delivery Fee',
    'Final Delivery Charge',
    'Remote Charge',
    '_og_selected_delivery_fee_amount',
    '_og_delivery_fee_amount',
    '_og_delivery_fee_variant_id',
    '_og_delivery_updated_at',
    '_og_delivery_sequence'
  ];

  const saveGlobalDeliveryState = deliveryState => {
    try {
      localStorage.setItem(DELIVERY_STORAGE_KEY, JSON.stringify(deliveryState));
    } catch (error) {
      console.warn('[OG Addon] Delivery state storage skipped:', error);
    }
  };

  const buildGlobalDeliveryState = () => {
    const location = getSelectedLocation();
    const deliveryType = cleanDeliveryTypeText(getSelectedDeliveryType());
    const deliveryDate = cleanDateText(getSelectedDateText());
    const deliverySlot = cleanSlotText(getSelectedDeliverySlot());
    const deliveryCharge = Math.max(0, Math.round(Number(getDeliveryFeeAmountFromPage() || 0)));
    const deliveryFeeVariantId = deliveryCharge > 0 ? getDeliveryFeeVariantId(deliveryCharge) : 0;
    const updatedAt = Date.now();
    const sequence = ++state.deliverySync.sequence;

    return {
      deliveryType,
      deliveryDate,
      deliverySlot,
      deliveryCharge,
      deliveryFeeVariantId: deliveryFeeVariantId ? String(deliveryFeeVariantId) : '',
      city: cleanValue(location.city),
      pincode: cleanValue(location.pincode),
      updatedAt,
      sequence
    };
  };

  const isDeliveryFeeCartItem = item => {
    const properties = item && item.properties ? item.properties : {};
    const configuredVariants = new Set(
      Object.values(config.deliveryFeeVariantByAmount || {})
        .map(Number)
        .filter(Boolean)
    );

    return (
      String(properties['_Is Delivery Fee'] || '').toLowerCase() === 'true' ||
      String(properties['_Delivery Fee Item'] || '').toLowerCase() === 'true' ||
      String(properties._og_delivery_fee || '').toLowerCase() === 'true' ||
      Number(item.product_id || 0) === Number(config.deliveryFeeProductId || 0) ||
      configuredVariants.has(Number(item.variant_id || 0))
    );
  };

  const isAddonCartItem = item => {
    const properties = item && item.properties ? item.properties : {};
    return String(properties._addon_item || '').toLowerCase() === 'true';
  };

  const getCartItemDeliveryMode = item => {
    const properties = item && item.properties ? item.properties : {};
    const rawMode = normalizeLower(
      properties['_Product Delivery Mode'] ||
      properties._og_parent_type ||
      properties._addon_parent_type ||
      properties._delivery_source ||
      ''
    );

    if (rawMode === 'express' || rawMode.includes('express')) return 'express';
    if (rawMode === 'courier' || rawMode.includes('courier')) return 'courier';
    return '';
  };

  const isExpressCartItem = item => (
    !isDeliveryFeeCartItem(item) &&
    !isAddonCartItem(item) &&
    getCartItemDeliveryMode(item) === 'express'
  );

  const isCourierCartItem = item => (
    !isDeliveryFeeCartItem(item) &&
    !isAddonCartItem(item) &&
    getCartItemDeliveryMode(item) === 'courier'
  );

  const removeDeliveryProperties = oldProperties => {
    const properties = { ...(oldProperties || {}) };
    DELIVERY_PROPERTY_KEYS.forEach(key => delete properties[key]);
    return properties;
  };

  const buildLatestDeliveryProperties = (oldProperties, deliveryState) => {
    const properties = { ...(oldProperties || {}) };

    DELIVERY_PROPERTY_KEYS.forEach(key => {
      delete properties[key];
    });

    if (deliveryState.city) properties['Delivery City'] = deliveryState.city;
    if (deliveryState.pincode) properties['Delivery Pincode'] = deliveryState.pincode;
    if (deliveryState.deliveryDate) properties['Delivery Date'] = deliveryState.deliveryDate;
    if (deliveryState.deliveryType) properties['Delivery Type'] = deliveryState.deliveryType;
    if (deliveryState.deliverySlot) properties['Delivery Slot'] = deliveryState.deliverySlot;

    properties['_og_delivery_updated_at'] = String(deliveryState.updatedAt);
    properties['_og_delivery_sequence'] = String(deliveryState.sequence);

    if (deliveryState.deliveryCharge > 0) {
      properties['_og_delivery_fee_amount'] = String(deliveryState.deliveryCharge);
      properties['_og_delivery_fee_variant_id'] = String(deliveryState.deliveryFeeVariantId || '');
    }

    return properties;
  };

  const setDeliverySavingUi = saving => {
    if (!els.continueBtn) return;
    els.continueBtn.disabled = Boolean(saving);
    els.continueBtn.setAttribute('aria-busy', saving ? 'true' : 'false');
    els.continueBtn.textContent = saving ? 'Saving delivery…' : 'Continue with Gift →';
  };

  const verifySingleDeliveryFee = async expectedState => {
    const expectedVariantId = Number(expectedState.deliveryFeeVariantId || 0);

    for (let attempt = 0; attempt < 2; attempt += 1) {
      const response = await fetch(apiUrl('/cart.js'), {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Unable to verify delivery charge.');

      const cart = await response.json();
      const feeItems = (cart.items || []).filter(isDeliveryFeeCartItem);

      const valid = expectedState.deliveryCharge > 0
        ? feeItems.length === 1 &&
          Number(feeItems[0].variant_id) === expectedVariantId &&
          Number(feeItems[0].quantity) === 1
        : feeItems.length === 0;

      if (valid) return cart;

      const updates = {};
      feeItems.forEach(item => {
        if (item.key) updates[item.key] = 0;
      });

      if (Object.keys(updates).length) {
        await postJson(apiUrl('/cart/update.js'), { updates });
      }

      if (expectedState.deliveryCharge > 0) {
        if (!expectedVariantId) {
          throw new Error(`Delivery fee variant is not configured for ₹${expectedState.deliveryCharge}.`);
        }

        await postJson(apiUrl('/cart/add.js'), {
          items: [{
            id: expectedVariantId,
            quantity: 1,
            properties: {
              'Delivery Fee': `${config.currencySymbol}${expectedState.deliveryCharge}`,
              '_Is Delivery Fee': 'true',
              '_Delivery Fee Item': 'true',
              '_og_delivery_fee': 'true',
              '_og_delivery_fee_amount': String(expectedState.deliveryCharge),
              '_og_delivery_fee_variant_id': String(expectedVariantId),
              '_og_delivery_updated_at': String(expectedState.updatedAt),
              '_og_delivery_sequence': String(expectedState.sequence)
            }
          }]
        });
      }
    }

    const finalResponse = await fetch(apiUrl('/cart.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!finalResponse.ok) throw new Error('Unable to confirm the final delivery charge.');

    const finalCart = await finalResponse.json();
    const finalFees = (finalCart.items || []).filter(isDeliveryFeeCartItem);
    const finalValid = expectedState.deliveryCharge > 0
      ? finalFees.length === 1 && Number(finalFees[0].variant_id) === expectedVariantId
      : finalFees.length === 0;

    if (!finalValid) {
      throw new Error('The delivery charge could not be synchronized. Please try again.');
    }

    return finalCart;
  };

  const applyDeliveryStateOnce = async deliveryState => {
    const mySequence = Number(deliveryState.sequence || 0);
    const response = await fetch(apiUrl('/cart.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) throw new Error('Unable to read the current cart.');
    if (mySequence < state.deliverySync.sequence) return null;

    const cart = await response.json();
    const items = Array.isArray(cart.items) ? cart.items : [];
    const expressItems = items.filter(isExpressCartItem);
    const courierItems = items.filter(isCourierCartItem);

    // Clean wrongly inherited Express fields from Courier lines while preserving
    // sender, gift message, personalisation and every unrelated property.
    for (const item of courierItems) {
      if (mySequence < state.deliverySync.sequence) return null;
      const properties = removeDeliveryProperties(item.properties);
      properties['_Product Delivery Mode'] = 'courier';

      if (JSON.stringify(properties) !== JSON.stringify(item.properties || {})) {
        await postJson(apiUrl('/cart/change.js'), {
          id: item.key,
          quantity: item.quantity,
          properties
        });
      }
    }

    // Only Express parent products receive the latest global Express selection.
    for (const item of expressItems) {
      if (mySequence < state.deliverySync.sequence) return null;
      const properties = buildLatestDeliveryProperties(item.properties, deliveryState);
      properties['_Product Delivery Mode'] = 'express';

      await postJson(apiUrl('/cart/change.js'), {
        id: item.key,
        quantity: item.quantity,
        properties
      });
    }

    if (mySequence < state.deliverySync.sequence) return null;

    // Fee existence depends only on whether at least one Express parent remains.
    const expectedState = expressItems.length
      ? deliveryState
      : { ...deliveryState, deliveryCharge: 0, deliveryFeeVariantId: '' };

    const verifiedCart = await verifySingleDeliveryFee(expectedState);
    if (expressItems.length) saveGlobalDeliveryState(deliveryState);
    return verifiedCart;
  };

  const queueGlobalDeliveryUpdate = deliveryState => {
    state.deliverySync.pending = deliveryState;

    if (state.deliverySync.applying) {
      return state.deliverySync.currentPromise || Promise.resolve(null);
    }

    state.deliverySync.applying = true;
    setDeliverySavingUi(true);

    state.deliverySync.currentPromise = (async () => {
      let result = null;

      try {
        while (state.deliverySync.pending) {
          const nextState = state.deliverySync.pending;
          state.deliverySync.pending = null;
          result = await applyDeliveryStateOnce(nextState);
        }

        await refreshCartSections();
        return result;
      } finally {
        state.deliverySync.applying = false;
        state.deliverySync.currentPromise = null;
        setDeliverySavingUi(false);
      }
    })();

    return state.deliverySync.currentPromise;
  };

  const buildVisibleSenderProperties = senderValues => {
    const props = {};

    if (senderValues.senderName) {
      props['Sender Name'] = senderValues.senderName;
    }

    if (senderValues.senderPhone) {
      props['Sender Phone Number'] = senderValues.senderPhone;
    }

    if (senderValues.message) {
      props['Message with Order'] = senderValues.message;
    }

    return props;
  };

  const getParentType = () => {
    if (config.currentProductIsCourier === true) return 'courier';
    if (config.currentProductIsExpress === true) return 'express';
    return '';
  };


  const replaceExistingSameProduct = async (parentVariantId, parentType) => {
    const variantId = Number(parentVariantId || 0);
    if (!variantId) return;

    const response = await fetch(apiUrl('/cart.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to check the existing cart configuration.');
    }

    const cart = await response.json();
    const items = Array.isArray(cart.items) ? cart.items : [];

    const matchingParents = items.filter(item => {
      return (
        Number(item.variant_id || 0) === variantId &&
        !isDeliveryFeeCartItem(item) &&
        !isAddonCartItem(item)
      );
    });

    const parentKeys = new Set(
      matchingParents.map(item => String(item.key || '')).filter(Boolean)
    );

    const groupIds = new Set(
      matchingParents
        .map(item => String(item.properties?._addon_group_id || '').trim())
        .filter(Boolean)
    );

    const updates = {};

    items.forEach(item => {
      if (!item || !item.key) return;

      /*
        Every previous delivery fee is removed before the new product
        configuration is written. The final fee is recreated once from
        the latest global delivery state.
      */
      if (isDeliveryFeeCartItem(item)) {
        if (parentType === 'express') updates[item.key] = 0;
        return;
      }

      if (matchingParents.some(parent => parent.key === item.key)) {
        updates[item.key] = 0;
        return;
      }

      if (!isAddonCartItem(item)) return;

      const properties = item.properties || {};
      const childParentKey = String(properties._addon_parent_key || '');
      const childGroupId = String(properties._addon_group_id || '');
      const childParentVariantId = Number(properties._addon_parent_variant_id || 0);

      if (
        parentKeys.has(childParentKey) ||
        groupIds.has(childGroupId) ||
        childParentVariantId === variantId
      ) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) return;

    await postJson(apiUrl('/cart/update.js'), { updates });

    const verifyResponse = await fetch(apiUrl('/cart.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!verifyResponse.ok) {
      throw new Error('Unable to confirm removal of the previous product configuration.');
    }

    const verifiedCart = await verifyResponse.json();
    const duplicateStillExists = (verifiedCart.items || []).some(item => {
      return (
        Number(item.variant_id || 0) === variantId &&
        !isDeliveryFeeCartItem(item) &&
        !isAddonCartItem(item)
      );
    });

    if (duplicateStillExists) {
      throw new Error('The previous product configuration could not be replaced. Please try once more.');
    }
  };

  const addItemsToCart = async senderValues => {
    const form = state.activeForm;

    if (!form) {
      throw new Error('Product form not found.');
    }

    const parentVariantId = Number(
      getSelectedVariantId(form) ||
      state.currentProductVariantId ||
      0
    );

    if (!parentVariantId) {
      throw new Error('Main product variant could not be found. Please refresh and try again.');
    }

    const parentQuantity = getQuantity(form);
    const sellingPlan = getSellingPlan(form);

    const groupId = `og_addon_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const selectedAddons = Array.from(state.selected.values());
    const visibleSenderProps = buildVisibleSenderProperties(senderValues);
    const deliveryFeeAmount = getDeliveryFeeAmountFromPage();
    const parentType = getParentType();

    const parentProperties = {
      ...getAllParentProperties(form, parentType),
      ...visibleSenderProps,
      '_addon_group_id': groupId,
      '_has_addons': selectedAddons.length ? 'true' : 'false',
      '_og_parent_type': parentType,
      '_addon_parent_type': parentType,
      '_Product Delivery Mode': parentType
    };

    if (parentType === 'express' && deliveryFeeAmount && Number(deliveryFeeAmount) > 0) {
      parentProperties['_og_delivery_fee_amount'] = String(Math.round(Number(deliveryFeeAmount)));
    } else {
      DELIVERY_PROPERTY_KEYS.forEach(key => delete parentProperties[key]);
    }

    if (parentProperties['Delivery Date']) {
      const cleanDate = cleanDateText(parentProperties['Delivery Date']);

      if (cleanDate) {
        parentProperties['Delivery Date'] = cleanDate;
      } else {
        delete parentProperties['Delivery Date'];
      }
    }

    const parentItem = {
      id: parentVariantId,
      quantity: parentQuantity,
      properties: parentProperties
    };

    if (sellingPlan) {
      parentItem.selling_plan = sellingPlan;
    }

    const deliveryState = buildGlobalDeliveryState();

    const addonItems = selectedAddons
      .filter(addon => Number(addon.variantId) !== Number(parentVariantId))
      .map(addon => {
        return {
          id: addon.variantId,
          quantity: parentQuantity,
          properties: {
            '_addon_item': 'true',
            '_addon_group_id': groupId,
            '_addon_for_product': getParentTitle(),
            '_addon_parent_variant_id': String(parentVariantId),
            '_addon_parent_key': `pending_${groupId}`,
            '_addon_parent_type': parentType
          }
        };
      });

    const items = [parentItem];

    items.push(...addonItems);

    /*
      Re-selecting the same product is treated as editing that product,
      not as adding a duplicate line. Remove its previous parent line and
      linked add-ons, then add the latest configuration once.
    */
    await replaceExistingSameProduct(parentVariantId, parentType);

    const added = await postJson(apiUrl('/cart/add.js'), {
      items
    });

    /*
      SPEED OPTIMIZATION:
      Do not run one /cart/change.js request per selected add-on here.
      _addon_group_id already links parent and child lines safely.
      This removes the biggest delay when multiple add-ons are selected.
    */

    if (parentType === 'express') {
      await queueGlobalDeliveryUpdate(deliveryState);
      await verifySingleDeliveryFee(deliveryState);
    }

    /*
      Do not block the customer on cart cleanup or section rendering.
      The add request (and Express fee verification when needed) is complete here.
      Drawer opens first; non-critical cleanup runs just after.
    */
    return added;
  };

  const patchAddonParentKey = async (addedResponse, groupId) => {
    const items = Array.isArray(addedResponse.items) ? addedResponse.items : [];

    if (items.length < 2) return;

    const parentKey = items[0] && items[0].key;

    if (!parentKey) return;

    const childItems = items.slice(1);

    for (const item of childItems) {
      if (!item || !item.key) continue;

      const oldProps = item.properties || {};
      const isAddon = String(oldProps._addon_item || '').toLowerCase() === 'true';

      if (!isAddon) continue;

      const properties = {
        ...oldProps,
        '_addon_parent_key': parentKey,
        '_addon_group_id': groupId,
        '_addon_item': 'true',
        '_addon_parent_type': oldProps._addon_parent_type || getParentType()
      };

      try {
        await postJson(apiUrl('/cart/change.js'), {
          id: item.key,
          quantity: item.quantity,
          properties
        });
      } catch (error) {
        console.warn('[OG Addon] Parent key patch skipped:', error);
      }
    }
  };

  /*
    IMPORTANT NEW CLEANUP LOGIC

    Requirement:
    - Cart me agar ek bhi express parent product bacha hai,
      to express add-ons cart me rahenge.
    - Customer add-ons ko manually ek-ek karke remove kar sakta hai.
    - Jab last express parent product remove ho jaye,
      tab express add-ons auto remove honge.
    - Courier parent ke liye bhi same safe logic.
    - Delivery fee item parent group specific rahega.
  */
  const cleanupCart = async () => {
    if (state.cleaning) return;

    state.cleaning = true;

    try {
      if (!state.loaded && isAddonEnabledProductPage()) {
        await loadProducts(false);
      }

      const response = await fetch(apiUrl('/cart.js'), {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const items = Array.isArray(cart.items) ? cart.items : [];

      const parentGroups = new Map();

      let hasExpressParent = false;
      let hasCourierParent = false;

      items.forEach(item => {
        const properties = item.properties || {};

        const groupId = properties._addon_group_id;
        const isAddon = String(properties._addon_item || '').toLowerCase() === 'true';
        const isDeliveryFee = isDeliveryFeeCartItem(item);

        if (!groupId || isAddon || isDeliveryFee) return;

        parentGroups.set(groupId, {
          quantity: item.quantity,
          item
        });

        const parentType = getCartItemDeliveryMode(item);

        if (parentType === 'express') hasExpressParent = true;
        if (parentType === 'courier') hasCourierParent = true;
      });


      const updates = {};

      items.forEach(item => {
        const properties = item.properties || {};

        const groupId = properties._addon_group_id;
        const feeGroupId = properties._og_delivery_fee_group_id;

        const isAddon = String(properties._addon_item || '').toLowerCase() === 'true';
        const isDeliveryFee = isDeliveryFeeCartItem(item);
        const isKnownAddonVariant = state.addonVariantIds.has(Number(item.variant_id));

        const addonParentType = normalizeLower(
          properties._addon_parent_type ||
          properties._og_parent_type ||
          properties._delivery_source ||
          ''
        );

        const addonText = normalizeLower(
          [
            item.title,
            item.product_title,
            Object.values(properties || {}).join(' ')
          ].join(' ')
        );

        const isExpressRelatedAddon =
          addonParentType.includes('express') ||
          addonText.includes('express') ||
          isKnownAddonVariant;

        const isCourierRelatedAddon =
          addonParentType.includes('courier') ||
          addonText.includes('courier');

        if (isAddon) {
          if (isCourierRelatedAddon) {
            if (!hasCourierParent) {
              updates[item.key] = 0;
            }

            return;
          }

          /*
            Default add-on source express maana gaya hai because normal add-ons
            collection express parent ke sath use hota hai.
          */
          if (isExpressRelatedAddon || !isCourierRelatedAddon) {
            if (!hasExpressParent) {
              updates[item.key] = 0;
            }

            return;
          }

          const parentGroup = groupId ? parentGroups.get(groupId) : null;

          if (!parentGroup && !hasExpressParent && !hasCourierParent) {
            updates[item.key] = 0;
          }

          return;
        }

        if (isDeliveryFee) {
          if (!hasExpressParent) {
            updates[item.key] = 0;
          } else if (item.quantity !== 1) {
            updates[item.key] = 1;
          }
          return;
        }

        /*
          Direct addon product block:
          Agar add-on variant normal product ki tarah add ho gaya hai,
          aur cart me koi parent nahi hai, to remove.
        */
        if (
          config.strictBlockAddonVariants &&
          isKnownAddonVariant &&
          !isAddon
        ) {
          const isCurrentMainProduct =
            Number(item.variant_id) === Number(state.currentProductVariantId);

          if (isCurrentMainProduct) return;

          if (!hasExpressParent && !hasCourierParent) {
            updates[item.key] = 0;
          }
        }
      });

      if (Object.keys(updates).length) {
        await postJson(apiUrl('/cart/update.js'), {
          updates
        });
      }
    } catch (error) {
      console.warn('[OG Addon] Cart cleanup skipped:', error);
    } finally {
      state.cleaning = false;
    }
  };

  const refreshCartSections = async () => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('og:cart:refresh', { bubbles: true }));

    try {
      const sections = [
        'cart-drawer',
        'cart-icon-bubble',
        'main-cart-items',
        'cart-footer'
      ];

      const response = await fetch(apiUrl(`/cart?sections=${sections.join(',')}`), {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const htmlBySection = await response.json();

      Object.entries(htmlBySection || {}).forEach(([sectionId, html]) => {
        if (!html) return;

        const currentSection = document.getElementById(`shopify-section-${sectionId}`);
        if (!currentSection) return;

        const temp = document.createElement('div');
        temp.innerHTML = html;

        const freshSection = temp.querySelector(`#shopify-section-${sectionId}`);

        if (freshSection) {
          currentSection.innerHTML = freshSection.innerHTML;
        }
      });
    } catch (error) {
      console.warn('[OG Addon] Cart section refresh skipped:', error);
    }
  };

  const closeWrongMobileMenu = () => {
    const openedDetails = $$(
      'header-drawer details[open], menu-drawer details[open], .menu-drawer-container details[open], details.menu-opening[open]'
    );

    openedDetails.forEach(details => {
      details.removeAttribute('open');
    });

    $$('header-drawer, menu-drawer, .menu-drawer-container, .mobile-menu, .mega-menu').forEach(node => {
      node.classList.remove('active', 'menu-opening', 'open', 'is-open');
      node.removeAttribute('open');
      node.removeAttribute('aria-expanded');
    });

    document.body.classList.remove('menu-opening', 'overflow-hidden-tablet');
    document.documentElement.classList.remove('menu-opening');
  };

  const openCartAfterAdd = async shouldRefresh => {
    closeWrongMobileMenu();
    unlockPage();

    const drawer =
      document.querySelector('cart-drawer#CartDrawer') ||
      document.querySelector('#CartDrawer.cart-drawer') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer');

    const openDrawerNow = () => {
      if (!drawer) return false;

      closeWrongMobileMenu();

      if (typeof drawer.open === 'function') {
        try {
          drawer.open();
        } catch (error) {
          console.warn('[OG Addon] Native cart drawer open skipped:', error);
        }
      }

      drawer.classList.add('active', 'animate');
      drawer.setAttribute('open', '');
      drawer.removeAttribute('hidden');
      drawer.removeAttribute('aria-hidden');

      const inner = drawer.querySelector('.drawer__inner, .drawer_inner, [class*="drawer__inner"]');

      if (inner) {
        inner.style.transform = 'translateX(0)';
        inner.style.visibility = 'visible';
      }

      return true;
    };

    /*
      UX SPEED:
      Open the drawer immediately. Do not make the customer wait for
      Shopify section rendering before seeing the cart.
    */
    const opened = openDrawerNow();

    if (shouldRefresh !== false) {
      window.setTimeout(async () => {
        try {
          await refreshCartSections();

          /*
            Some themes rebuild drawer inner HTML during section refresh.
            Re-assert open state once, without another delay.
          */
          openDrawerNow();
        } catch (error) {
          console.warn('[OG Addon] Deferred cart refresh skipped:', error);
        }
      }, 0);
    }

    if (opened) return;

    const trigger =
      config.cartDrawerTriggerSelector
        ? document.querySelector(config.cartDrawerTriggerSelector)
        : null;

    if (trigger) {
      closeWrongMobileMenu();
      trigger.click();
      return;
    }

    /*
      Last fallback only when the theme has no cart drawer.
    */
    window.location.href = apiUrl('/cart');
  };

  const findProductFormFromButton = button => {
    return (
      button.closest(config.productFormSelector) ||
      button.closest('form') ||
      document.querySelector(config.productFormSelector)
    );
  };

  const isBuyButton = button => {
    if (!button) return false;

    const buttonText = normalizeLower(button.textContent || button.value || '');

    return (
      button.matches(config.buyNowSelector) ||
      buttonText.includes('send this gift now') ||
      buttonText.includes('buy now') ||
      buttonText.includes('add to cart') ||
      buttonText.includes('send gift') ||
      buttonText.includes('send this gift')
    );
  };

  const handleBuyNowClick = async event => {
    if (!isAddonEnabledProductPage()) return;

    const button = event.target.closest(
      `${config.buyNowSelector}, button[type="submit"], input[type="submit"], [data-add-to-cart], [data-product-submit]`
    );

    if (!button) return;
    if (!isBuyButton(button)) return;

    const form = findProductFormFromButton(button);

    if (!form || !form.matches(config.productFormSelector)) return;

    if (state.adding) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (!validateProductForm(form)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    await openPopup(form);
  };

  const handleFormSubmit = async event => {
    if (!isAddonEnabledProductPage()) return;

    const form = event.target;

    if (!form || !form.matches(config.productFormSelector)) return;

    const submitter = event.submitter;
    const fromBuyButton = submitter && isBuyButton(submitter);

    if (!fromBuyButton) return;

    if (state.adding) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (!validateProductForm(form)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    await openPopup(form);
  };

  const handleDirectAddonBlock = event => {
    if (!config.strictBlockAddonVariants) return;
    if (!state.addonVariantIds.size) return;
    if (state.adding) return;

    const form = event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;

    if (!form) return;

    const variantId = getSelectedVariantId(form);

    if (state.addonVariantIds.has(Number(variantId))) {
      const isCurrentProductPageVariant = Number(variantId) === Number(state.currentProductVariantId);

      if (isCurrentProductPageVariant) return;

      event.preventDefault();
      event.stopPropagation();

      alert('This add-on product can be ordered only with a main gift product.');
    }
  };

  const submitFinal = async () => {
    if (state.adding || window.OG_ADDON_CART_SUBMIT_LOCK === true) return;

    state.adding = true;
    window.OG_ADDON_CART_SUBMIT_LOCK = true;
    setStatus('');

    if (els.continueBtn) {
      els.continueBtn.disabled = true;
      els.continueBtn.textContent = 'Adding...';
    }

    try {
      await addItemsToCart({});

      await closePopup({ openCart: false });

      /*
        Drawer opens immediately. Cart section refresh happens asynchronously
        inside openCartAfterAdd().
      */
      await openCartAfterAdd(true);

      /*
        Non-critical orphan cleanup should never delay the drawer.
        If cleanup changes anything, existing cart events / later cart refresh
        keep the UI consistent.
      */
      window.setTimeout(() => {
        cleanupCart().catch(error => {
          console.warn('[OG Addon] Deferred cleanup skipped:', error);
        });
      }, 250);

      return;
    } catch (error) {
      console.error('[OG Addon] Add error:', error);
      setStatus(error.message || 'Unable to add gift to cart.', 'error');
    } finally {
      state.adding = false;
      window.OG_ADDON_CART_SUBMIT_LOCK = false;

      if (els.continueBtn) {
        els.continueBtn.disabled = false;
      }

      updateSummary();
    }
  };

  const handleContinue = () => {
    submitFinal();
  };

  const bindCartUnlockEvents = () => {
    document.addEventListener('click', event => {
      const closeClicked = event.target.closest(
        '#CartDrawer .drawer__close, cart-drawer .drawer__close, #CartDrawer [aria-label="Close"], cart-drawer [aria-label="Close"], #CartDrawer .drawer__overlay, cart-drawer .drawer__overlay, .cart-drawer__overlay'
      );

      if (closeClicked) {
        window.setTimeout(unlockPage, 250);
        window.setTimeout(unlockPage, 700);
      }
    }, true);

    document.addEventListener('keyup', event => {
      if (event.key === 'Escape') {
        window.setTimeout(unlockPage, 250);
      }
    });

    document.addEventListener('cart-drawer:close', () => {
      window.setTimeout(unlockPage, 200);
    });

    document.addEventListener('drawer:close', () => {
      window.setTimeout(unlockPage, 200);
    });
  };

  const bindEvents = () => {
    document.addEventListener('click', handleBuyNowClick, true);
    document.addEventListener('submit', handleFormSubmit, true);

    document.addEventListener('submit', handleDirectAddonBlock, true);
    document.addEventListener('click', handleDirectAddonBlock, true);

    $$('[data-og-addon-close]', popup).forEach(node => {
      node.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        closePopup({ openCart: false });
      });
    });

    if (els.continueBtn) {
      els.continueBtn.addEventListener('click', handleContinue);
    }

    if (els.back) {
      els.back.addEventListener('click', () => {
        saveSenderDetails();
        setSlide('addons');
      });
    }

    if (els.skip) {
      if (!config.enableSkipAddons) {
        hide(els.skip);
      } else {
        els.skip.addEventListener('click', () => {
          if (state.adding) return;

          /*
            IMPORTANT:
            Skip only means "do not select more add-ons".
            If customer has already selected add-ons, keep them and add them
            together with the main product — same as CONTINUE.
          */
          submitFinal();
        });
      }
    }

    if (els.occasionButtons) {
      els.occasionButtons.forEach(button => {
        button.addEventListener('click', () => {
          if (els.occasionSelect) els.occasionSelect.value = '';
          renderOccasionMessages(Number(button.dataset.ogOccasionId || 0));
        });
      });
    }

    if (els.occasionSelect) {
      els.occasionSelect.addEventListener('change', () => {
        renderOccasionMessages(Number(els.occasionSelect.value || 0));
      });
    }

    if (els.suggestedOpen) {
      els.suggestedOpen.addEventListener('click', openSuggestedMessages);
    }

    if (els.messageModalClose) {
      els.messageModalClose.forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          closeSuggestedMessages();
        });
      });
    }

    const messageDialog = $('.og-addon__message-modal-dialog', popup);
    if (messageDialog) {
      messageDialog.addEventListener('click', event => {
        event.stopPropagation();
      });
    }

    [els.senderName, els.senderPhone, els.senderMessage].forEach(input => {
      if (!input) return;

      input.addEventListener('input', () => {
        if (input === els.senderPhone) {
          els.senderPhone.value = els.senderPhone.value.replace(/\D/g, '').slice(0, 10);
        }

        saveSenderDetails();
      });

      input.addEventListener('change', saveSenderDetails);
      input.addEventListener('blur', saveSenderDetails);
    });

    if (els.senderPhone) {
      els.senderPhone.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          submitFinal();
        }
      });
    }

    if (els.senderMessage) {
      els.senderMessage.addEventListener('keydown', event => {
        if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
          event.preventDefault();
          submitFinal();
        }
      });
    }

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;

      if (els.messageModal && !els.messageModal.hidden) {
        event.preventDefault();
        event.stopPropagation();
        closeSuggestedMessages();
        return;
      }

      if (!popup.hidden) {
        event.preventDefault();

        if (state.currentSlide === 'addons') {
          setSlide('sender');
        } else {
          submitFinal();
        }
      }
    });

    [
      'cart:updated',
      'cart:refresh',
      'ajaxCart:updated',
      'cart-drawer:updated',
      'cart:change',
      'cart:remove'
    ].forEach(eventName => {
      document.addEventListener(eventName, () => {
        window.setTimeout(cleanupCart, 350);
      });
    });

    document.addEventListener('change', event => {
      if (
        event.target &&
        (
          event.target.matches('[name="updates[]"]') ||
          event.target.matches('.quantity__input') ||
          event.target.closest('.cart-item')
        )
      ) {
        window.setTimeout(cleanupCart, 650);
      }
    });

    document.addEventListener('click', event => {
      const removeClicked = event.target.closest(
        'cart-remove-button, .cart-remove-button, [href*="/cart/change"], [data-cart-remove], [data-remove], button[name="minus"], .quantity__button'
      );

      if (removeClicked) {
        window.setTimeout(cleanupCart, 900);
        window.setTimeout(refreshCartSections, 1200);
      }
    });

    window.addEventListener('pageshow', () => {
      window.setTimeout(unlockPage, 150);
      window.setTimeout(cleanupCart, 500);
    });

    bindCartUnlockEvents();
  };

  bindEvents();

  window.setTimeout(() => {
    if (isAddonEnabledProductPage()) {
      loadProducts(false);
    }

    unlockPage();
  }, 900);

  window.OGAddonPopup = {
    open: openPopup,
    close: () => closePopup({ openCart: false }),
    cleanupCart,
    syncDelivery: () => queueGlobalDeliveryUpdate(buildGlobalDeliveryState()),
    unlockPage,
    reloadAddons: async () => {
      state.loaded = false;
      state.products = [];
      state.categoryProducts.clear();
      state.categoryStatus.clear();
      state.activeCategoryKey = '';
      state.categoriesReady = false;
      state.addonVariantIds.clear();
      await loadProducts(true);
    }
  };
})();